import { render } from "./colores.vue?vue&type=template&id=352e887e"
import script from "./colores.vue?vue&type=script&lang=js"
export * from "./colores.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__